import React from 'react';
import type {MessageDescriptor} from 'react-intl';
import {useAutoMapper} from '@igp/shared/auto-mapper';
import {DownloadCsvButton} from '@igp/shared/components/download';
import type {UseDownloadProps, UseDownloadResult} from '@igp/shared/redux/download';
import {useDownload} from '@igp/shared/redux/download';

import {repaymentLogLocalizedHeaders} from '../localized';
import {repaymentLogMappingKeys} from '../mapper';
import type {RepaymentLogColumns, RepaymentLogViewModelKeys} from '../types';
import {RepaymentLogServiceTypes} from '../types';

type RepaymentLogDownloadCsvButtonProps = Pick<UseDownloadProps<RepaymentLogViewModelKeys>, 'filename' | 'filter' | 'mode' | 'total'> & {
    columns: RepaymentLogColumns[];
};

function useRepaymentLogDownload({columns, ...props}: RepaymentLogDownloadCsvButtonProps): UseDownloadResult {
    const mapper = useAutoMapper();
    const keys = [
        ...new Set(
            columns.flatMap(c =>
                mapper.map<RepaymentLogColumns, RepaymentLogViewModelKeys[]>(
                    c,
                    repaymentLogMappingKeys.columns,
                    repaymentLogMappingKeys.viewModelsKeys
                )
            )
        ),
    ];
    const {handleDownload, isProgress} = useDownload<RepaymentLogViewModelKeys>({
        ...props,
        strategySymbol:
            props.mode === 'client' ? RepaymentLogServiceTypes.downloadClientStrategy : RepaymentLogServiceTypes.downloadServerStrategy,
        headersLocalization: repaymentLogLocalizedHeaders as Record<RepaymentLogViewModelKeys, MessageDescriptor>,
        keys,
    });

    return {handleDownload, isProgress};
}

export function RepaymentLogDownloadCsvButton(props: RepaymentLogDownloadCsvButtonProps) {
    const {handleDownload, isProgress} = useRepaymentLogDownload(props);
    return <DownloadCsvButton onClick={handleDownload} loading={isProgress} disabled={isProgress || !props.total} />;
}
